import { render, staticRenderFns } from "./PromotionMessageValidation.vue?vue&type=template&id=30e81366&scoped=true"
import script from "./PromotionMessageValidation.vue?vue&type=script&lang=js"
export * from "./PromotionMessageValidation.vue?vue&type=script&lang=js"
import style0 from "./PromotionMessageValidation.scss?vue&type=style&index=0&id=30e81366&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e81366",
  null
  
)

export default component.exports